export const cssBundleHref = "/build/css-bundle-KAHDDDRD.css";